import React, {useEffect, useRef, useState} from 'react';
import { observer } from 'mobx-react';
import { api } from '../../config';

// Helpers
import { getPath } from '../../helpers/helpers';

const LoadMore = observer((props) => {

  const [url, setUrl] = useState(null);
  const [clicked, setClicked] = useState(false);
  const [done, setDone] = useState(false);
  const buttonRef = useRef(null);

  useEffect(() => {
    setUrl(props.url)
  }, [])

  const loadFunction = () => {
    const { SessionStore } = props.store;
    if(!url) return;
        if(!done) {
          api.get(url)
              .then(response => {
                if(!props.dataFormat || props.concat) {
                      Array.prototype.push.apply(props.group, response.data.results);
                  }


                if(props.dataFormat) {
                  props.dataSet(
                      props.dataFormat(response.data.results)
                  );
                }

                setClicked(false)

                if(response.data.next) {
                  // API returns a url with a different domain for the next link
                  // so create an anchor element and set its href to the next link
                  // and then grab the pathname and query from that
                  let nextUrl = getPath(response.data.next);
                  nextUrl = nextUrl.replace('/v1', '');

                  if(nextUrl !== url ) {
                    setUrl(nextUrl)
                  } else {
                    setUrl(null)
                  }
                } else {


                  setUrl(null);
                  setDone(true);
                }
              })
              .catch(error => {
                SessionStore.throwError(error);
              });
        }

  }

  const isVisible = () => {
    if(buttonRef) {
      const button = buttonRef.current.getBoundingClientRect();
      return button.top <= window.innerHeight;
    }
  }



  useEffect(() => {

    const scrollHandler = () => {
      if (isVisible()) {
        setClicked(true);
        loadFunction();
      }
    };
    if(props.drawer){
      const drawer = document.querySelector('.drawer');
      drawer.addEventListener('scroll', scrollHandler);
    } else if(props.wrapper){
      const wrapper = document.querySelector(props.wrapper);
      wrapper.addEventListener('scroll', scrollHandler);
    } else {
      window.addEventListener('scroll', scrollHandler);
    }


    return () => {
      if(props.drawer){
        const drawer = document.querySelector('.drawer');
        drawer.removeEventListener('scroll', scrollHandler);
      } else if(props.wrapper){
        const wrapper = document.querySelector(props.wrapper);
        if(wrapper){
          wrapper.removeEventListener('scroll', scrollHandler);
        }
      } else {
        window.removeEventListener('scroll', scrollHandler);
      }
      // Cleanup: Remove the event listener when the component is unmounted
    };
  }, [url]);

  const { SessionStore } = props.store;

    if(!SessionStore.loading) {
      if(url && !done) {
        if(!clicked) {
          return (
            <button
              className="btn btn--more"
              onClick={() => loadFunction()}
              ref={buttonRef}
            >
              {props.text}
            </button>
          );
        } else {
          return (
            <span className="loader-bar">Loading…</span>
          );
        }
      }
    }
})

export default LoadMore;



// WEBPACK FOOTER //
// ./src/app/components/Common/LoadMore.js